module.exports = __webpack_public_path__ + "img/download.b7e1953c.jpg";